// import "./App.css";
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

import React from 'react';
import { createStore } from 'redux';
import { Provider } from 'react-redux';
import { Routes, Route, Navigate, BrowserRouter } from 'react-router-dom';

import { composeWithDevTools } from 'redux-devtools-extension';
import { CookiesProvider } from 'react-cookie';
import AdminLayout from './layout/admin';
import ScrollToTop from './layout/ScrollToTop';

import reducer from './store/reducer';
import config from './config';

import routes from './routes';
import routesAdmin from './routesAdmin';

const store = createStore(reducer, composeWithDevTools());
// const customHistory = createBrowserHistory();

function App() {
    let singlePage = [];
    for (const key in routes) {
        const subMenu = routes[key].map((route, index) => {
            return route.component ? <Route key={index} path={key + '/' + route.path} exact={route.exact} name={route.name} element={route.component} /> : null;
        });
        singlePage = singlePage.concat(subMenu);
    }

    let adminPage = [];
    for (const key in routesAdmin) {
        const subMenu = routesAdmin[key].map((route, index) => {
            return route.component ? <Route key={index} path={key + '/' + route.path} exact={route.exact} name={route.name} element={route.component} /> : null;
        });
        adminPage = adminPage.concat(subMenu);
    }

    return (
        <Provider store={store}>
            <BrowserRouter>
                <CookiesProvider>
                    <ScrollToTop>
                        <Routes>
                            {singlePage}
                            <Route path="/a" element={<AdminLayout />}>
                                {adminPage}
                            </Route>
                            <Route path="*" element={<Navigate to="/auth/login" />} />
                        </Routes>
                    </ScrollToTop>
                </CookiesProvider>
            </BrowserRouter>
        </Provider>
    );
}

export default App;
